export default __webpack_public_path__ + "static/media/allow_edit.eb1636a4.svg";